import _ from "lodash";
import BackButton from "../common/navigation/BackButton";
import Button from "../common/F7/Button";
import ButtonSmall from "../common/F7/ButtonSmall";
import F7 from "../../utils/F7";
import ListBlock from "../common/F7/ListBlock";
import ListBlockItem from "../common/F7/ListBlockItem";
import Page from "../common/navigation/Page";
import React, { FC, useCallback, useMemo, useState } from "react";
import Spinner from "../common/F7/Spinner";
import { useNavigate } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";
import { useDeleteProject } from "../../hooks/database/usePouchDelete";
import { useUpdateProject } from "../../hooks/database/usePouchUpdate";
import { useCurrentProject } from "../../hooks/database/useCurrentProject";
import DangerZoneCard from "../common/F7/DangerZoneCard";
import { useCurrentDatabaseId } from "../../hooks/url";

const ProjectEditPage: FC = () => {
  const [change, setChange] = useState(false);
  const { canAddInventory, canDeleteProject, canToggleInProjectSettings } = usePermissions();

  const navigate = useNavigate();

  const { data: project } = useCurrentProject();
  const { execute: deleteProject } = useDeleteProject();
  const { execute: updateProject } = useUpdateProject();
  const { databaseId } = useCurrentDatabaseId();

  const inventories = useMemo(() => project?.inventories || {}, [project]);

  const handleDeleteClick = useCallback(() => {
    F7.confirm("This action cannot be undone", "Delete Project?", async () => {
      if (!project) {
        return;
      }
      await deleteProject(project);
      navigate("../..");
    });
  }, [project, deleteProject, navigate]);

  const deleteInventory = useCallback(
    async (inventoryId: string) => {
      if (!project) {
        return;
      }

      await updateProject({
        ...project,
        inventories: _.omit(inventories || {}, inventoryId),
      });
    },
    [inventories, project, updateProject],
  );
  const handleDeleteInventoryClick = useCallback(
    (inventoryId: string) => {
      F7.confirm("This action cannot be undone", "Delete inventory?", async () => {
        await deleteInventory(inventoryId);
      });
    },
    [deleteInventory],
  );
  const handleCancel = useCallback(() => {
    //const pid = project && project._id;
    navigate(`/d/${databaseId}/p`);
  }, [navigate, databaseId]);
  const handleEditToggle = useCallback(() => {
    setChange(!change);
  }, [change]);

  if (!project) {
    return <Spinner />;
  }

  return (
    <Page navbarLeft={<BackButton onClick={handleCancel}>Close editor</BackButton>} title={project.name}>
      <div className="projectbuttonContainer">
        {canToggleInProjectSettings && Object.keys(inventories).length ? (
          <ButtonSmall onClick={handleEditToggle}>{change ? "Done" : "Change"}</ButtonSmall>
        ) : null}
      </div>
      {Object.keys(inventories).length ? (
        <div className="margintop20">
          <ListBlock title="Inventories">
            {Object.entries(inventories).map(([key, inventory]) => (
              <ListBlockItem
                media={
                  change ? (
                    <i
                      className="fa fa-minus-circle removeIcon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteInventoryClick(key);
                      }}
                    />
                  ) : null
                }
                key={key}
                title={inventory.name}
                to={`../../../i/${key}/edit`}
              />
            ))}
          </ListBlock>
        </div>
      ) : null}
      {canAddInventory ? <Button to="../i/new">Add Inventory</Button> : null}
      {canDeleteProject ? (
        <DangerZoneCard header="Danger zone">
          <Button style={{ marginTop: 10 }} color="red" onClick={handleDeleteClick}>
            Delete Project
          </Button>
        </DangerZoneCard>
      ) : null}
    </Page>
  );
};

export default ProjectEditPage;
